import {
  COURSE_LIST_REQUEST,
  COURSE_LIST_FAILURE,
  COURSE_LIST_SUCCESS,
  ADD_COURSE_REQUEST,
  ADD_COURSE_SUCCESS,
  ADD_COURSE_FAILURE,
  EDIT_COURSE_REQUEST,
  EDIT_COURSE_SUCCESS,
  EDIT_COURSE_FAILURE,
  DELETE_COURSE_REQUEST,
  DELETE_COURSE_SUCCESS,
  DELETE_COURSE_FAILURE,
  COURSE_BY_ID_REQUEST,
  COURSE_BY_ID_SUCCESS,
  COURSE_BY_ID_FAILURE,
  PENDING_COURSE_ENROLLMENT_EDUCATORS_REQUEST,
  PENDING_COURSE_ENROLLMENT_EDUCATORS_SUCCESS,
  PENDING_COURSE_ENROLLMENT_EDUCATORS_FAILURE,
  COURSE_MATERIAL_LIST_REQUEST,
  COURSE_MATERIAL_LIST_SUCCESS,
  COURSE_MATERIAL_LIST_FAILURE,
  ADD_COURSE_MATERIAL_REQUEST,
  ADD_COURSE_MATERIAL_SUCCESS,
  ADD_COURSE_MATERIAL_FAILURE,
  EDIT_COURSE_MATERIAL_REQUEST,
  EDIT_COURSE_MATERIAL_SUCCESS,
  EDIT_COURSE_MATERIAL_FAILURE,
  COURSE_MATERIAL_BY_ID_REQUEST,
  COURSE_MATERIAL_BY_ID_SUCCESS,
  COURSE_MATERIAL_BY_ID_FAILURE,
  DELETE_COURSE_MATERIAL_REQUEST,
  DELETE_COURSE_MATERIAL_SUCCESS,
  DELETE_COURSE_MATERIAL_FAILURE,
  GET_SCO_LIST_BY_COURSE_ID_REQUEST,
  GET_SCO_LIST_BY_COURSE_ID_SUCCESS,
  GET_SCO_LIST_BY_COURSE_ID_FAILURE,
  UPDATE_SCO_LIST_REQUEST,
} from "./actionTypes";
import {
  CourseListPayload,
  CourseListRequest,
  CourseListSuccess,
  CourseListSuccessPayload,
  CourseListFailure,
  CourseListFailurePayload,
  DeleteCoursePayload,
  DeleteCourseRequest,
  DeleteCourseSuccessPayload,
  DeleteCourseSuccess,
  DeleteCourseFailurePayload,
  DeleteCourseFailure,
  AddEditCoursePayload,
  AddCourseRequest,
  AddEditCourseSuccessPayload,
  AddCourseSuccess,
  AddEditCourseFailurePayload,
  AddCourseFailure,
  EditCourseSuccess,
  EditCourseRequest,
  EditCourseFailure,
  CourseByIdPayload,
  CourseByIdRequest,
  CourseByIdSuccessPayload,
  CourseByIdSuccess,
  CourseByIdFailurePayload,
  CourseByIdFailure,
  CourseMaterialListPayload,
  CourseMaterialListRequest,
  CourseMaterialListSuccessPayload,
  CourseMaterialListSuccess,
  CourseMaterialListFailurePayload,
  CourseMaterialListFailure,
  AddCourseMaterialPayload,
  AddCourseMaterialRequest,
  AddEditCourseMaterialSuccessPayload,
  AddCourseMaterialSuccess,
  AddEditCourseMaterialFailurePayload,
  AddCourseMaterialFailure,
  EditCourseMaterialPayload,
  EditCourseMaterialRequest,
  EditCourseMaterialSuccess,
  EditCourseMaterialFailure,
  CourseMaterialByIdPayload,
  CourseMaterialByIdRequest,
  CourseMaterialByIdSuccessPayload,
  CourseMaterialByIdSuccess,
  CourseMaterialByIdFailurePayload,
  CourseMaterialByIdFailure,
  DeleteCourseMaterialPayload,
  DeleteCourseMaterialRequest,
  DeleteCourseMaterialSuccessPayload,
  DeleteCourseMaterialSuccess,
  DeleteCourseMaterialFailure,
  DeleteCourseMaterialFailurePayload,
  GetSCOListByCourseIdRequest,
  GetSCOListByCourseIdSuccessPayload,
  GetSCOListByCourseIdSuccess,
  GetSCOListByCourseIdFailurePayload,
  GetSCOListByCourseIdFailure,
  GetSCOListByCourseIdPayload,
  UpdateSCOListRequestPayload,
  UpdateSCOListRequest,
  PendingCourseEnrollmentEducatorsPayload,
  PendingCourseEnrollmentEducatorsSuccessPayload,
  PendingCourseEnrollmentEducatorsFailurePayload,
} from "./types";

export const courseListRequest = (
  payload: CourseListPayload
): CourseListRequest => ({
  type: COURSE_LIST_REQUEST,
  payload,
});

export const courseListSuccess = (
  payload: CourseListSuccessPayload
): CourseListSuccess => ({
  type: COURSE_LIST_SUCCESS,
  payload,
});

export const courseListFailure = (
  payload: CourseListFailurePayload
): CourseListFailure => ({
  type: COURSE_LIST_FAILURE,
  payload,
});

export const addCourseRequest = (
  payload: AddEditCoursePayload
): AddCourseRequest => ({
  type: ADD_COURSE_REQUEST,
  payload,
});

export const addCourseSuccess = (
  payload: AddEditCourseSuccessPayload
): AddCourseSuccess => ({
  type: ADD_COURSE_SUCCESS,
  payload,
});

export const addCourseFailure = (
  payload: AddEditCourseFailurePayload
): AddCourseFailure => ({
  type: ADD_COURSE_FAILURE,
  payload,
});

export const editCourseRequest = (
  payload: AddEditCoursePayload
): EditCourseRequest => ({
  type: EDIT_COURSE_REQUEST,
  payload,
});

export const editCourseSuccess = (
  payload: AddEditCourseSuccessPayload
): EditCourseSuccess => ({
  type: EDIT_COURSE_SUCCESS,
  payload,
});

export const editCourseFailure = (
  payload: AddEditCourseFailurePayload
): EditCourseFailure => ({
  type: EDIT_COURSE_FAILURE,
  payload,
});

export const deleteCourseRequest = (
  payload: DeleteCoursePayload
): DeleteCourseRequest => ({
  type: DELETE_COURSE_REQUEST,
  payload,
});

export const deleteCourseSuccess = (
  payload: DeleteCourseSuccessPayload
): DeleteCourseSuccess => ({
  type: DELETE_COURSE_SUCCESS,
  payload,
});

export const deleteCourseFailure = (
  payload: DeleteCourseFailurePayload
): DeleteCourseFailure => ({
  type: DELETE_COURSE_FAILURE,
  payload,
});

export const courseByIdRequest = (
  payload: CourseByIdPayload
): CourseByIdRequest => ({
  type: COURSE_BY_ID_REQUEST,
  payload,
});

export const courseByIdSuccess = (
  payload: CourseByIdSuccessPayload
): CourseByIdSuccess => ({
  type: COURSE_BY_ID_SUCCESS,
  payload,
});

export const courseByIdFailure = (
  payload: CourseByIdFailurePayload
): CourseByIdFailure => ({
  type: COURSE_BY_ID_FAILURE,
  payload,
});

export const courseMaterialListRequest = (
  payload: CourseMaterialListPayload
): CourseMaterialListRequest => ({
  type: COURSE_MATERIAL_LIST_REQUEST,
  payload,
});

export const courseMaterialListSuccess = (
  payload: CourseMaterialListSuccessPayload
): CourseMaterialListSuccess => ({
  type: COURSE_MATERIAL_LIST_SUCCESS,
  payload,
});

export const courseMaterialListFailure = (
  payload: CourseMaterialListFailurePayload
): CourseMaterialListFailure => ({
  type: COURSE_MATERIAL_LIST_FAILURE,
  payload,
});

export const addCourseMaterialRequest = (
  payload: AddCourseMaterialPayload
): AddCourseMaterialRequest => ({
  type: ADD_COURSE_MATERIAL_REQUEST,
  payload,
});

export const addCourseMaterialSuccess = (
  payload: AddEditCourseMaterialSuccessPayload
): AddCourseMaterialSuccess => ({
  type: ADD_COURSE_MATERIAL_SUCCESS,
  payload,
});

export const addCourseMaterialFailure = (
  payload: AddEditCourseMaterialFailurePayload
): AddCourseMaterialFailure => ({
  type: ADD_COURSE_MATERIAL_FAILURE,
  payload,
});

export const editCourseMaterialRequest = (
  payload: EditCourseMaterialPayload
): EditCourseMaterialRequest => ({
  type: EDIT_COURSE_MATERIAL_REQUEST,
  payload,
});

export const editCourseMaterialSuccess = (
  payload: AddEditCourseMaterialSuccessPayload
): EditCourseMaterialSuccess => ({
  type: EDIT_COURSE_MATERIAL_SUCCESS,
  payload,
});

export const editCourseMaterialFailure = (
  payload: AddEditCourseMaterialFailurePayload
): EditCourseMaterialFailure => ({
  type: EDIT_COURSE_MATERIAL_FAILURE,
  payload,
});

export const courseMaterialByIdRequest = (
  payload: CourseMaterialByIdPayload
): CourseMaterialByIdRequest => ({
  type: COURSE_MATERIAL_BY_ID_REQUEST,
  payload,
});

export const courseMaterialByIdSuccess = (
  payload: CourseMaterialByIdSuccessPayload
): CourseMaterialByIdSuccess => ({
  type: COURSE_MATERIAL_BY_ID_SUCCESS,
  payload,
});

export const courseMaterialByIdFailure = (
  payload: CourseMaterialByIdFailurePayload
): CourseMaterialByIdFailure => ({
  type: COURSE_MATERIAL_BY_ID_FAILURE,
  payload,
});

export const deleteCourseMaterialRequest = (
  payload: DeleteCourseMaterialPayload
): DeleteCourseMaterialRequest => ({
  type: DELETE_COURSE_MATERIAL_REQUEST,
  payload,
});

export const deleteCourseMaterialSuccess = (
  payload: DeleteCourseMaterialSuccessPayload
): DeleteCourseMaterialSuccess => ({
  type: DELETE_COURSE_MATERIAL_SUCCESS,
  payload,
});

export const deleteCourseMaterialFailure = (
  payload: DeleteCourseMaterialFailurePayload
): DeleteCourseMaterialFailure => ({
  type: DELETE_COURSE_MATERIAL_FAILURE,
  payload,
});

export const getSCOListByCourseIdRequest = (
  payload: GetSCOListByCourseIdPayload
): GetSCOListByCourseIdRequest => ({
  type: GET_SCO_LIST_BY_COURSE_ID_REQUEST,
  payload,
});

export const getSCOListByCourseIdSuccess = (
  payload: GetSCOListByCourseIdSuccessPayload
): GetSCOListByCourseIdSuccess => ({
  type: GET_SCO_LIST_BY_COURSE_ID_SUCCESS,
  payload,
});

export const getSCOListByCourseIdFailure = (
  payload: GetSCOListByCourseIdFailurePayload
): GetSCOListByCourseIdFailure => ({
  type: GET_SCO_LIST_BY_COURSE_ID_FAILURE,
  payload,
});

export const updateSCOListRequest = (
  payload: UpdateSCOListRequestPayload
): UpdateSCOListRequest => ({
  type: UPDATE_SCO_LIST_REQUEST,
  payload,
});

export const pendingCourseEnrollmentEducatorsRequest = (
  payload: PendingCourseEnrollmentEducatorsPayload
) => ({
  type: PENDING_COURSE_ENROLLMENT_EDUCATORS_REQUEST,
  payload,
});

export const pendingCourseEnrollmentEducatorsSuccess = (
  payload: PendingCourseEnrollmentEducatorsSuccessPayload
) => ({
  type: PENDING_COURSE_ENROLLMENT_EDUCATORS_SUCCESS,
  payload,
});

export const pendingCourseEnrollmentEducatorsFailure = (
  payload: PendingCourseEnrollmentEducatorsFailurePayload
) => ({
  type: PENDING_COURSE_ENROLLMENT_EDUCATORS_FAILURE,
  payload,
});
